import {
    Card,
    Divider,
    Flex,
    NumberInput,
    Select,
    SelectItem,
    Text,
    Title,
} from '@tremor/react'
import type { InputsState, Provider, WorkloadProfile } from '../types'

interface Props {
    inputs: InputsState
    setInputs: (updates: Partial<InputsState>) => void
}

export default function ProviderStep({ inputs, setInputs }: Props) {
    return (
        <Card className="bg-teal-800 ring-teal-900">
            <Title className="text-white">Provider & Workload</Title>
            <Divider />
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">Provider</Text>
                <Select
                    value={inputs.provider}
                    onValueChange={(v) =>
                        setInputs({ provider: (v as Provider) || 'aws' })
                    }
                    className="w-full md:w-64"
                >
                    <SelectItem value="aws">Amazon Web Services</SelectItem>
                    <SelectItem value="gcp">Google Cloud</SelectItem>
                    <SelectItem value="azure">Microsoft Azure</SelectItem>
                    <SelectItem value="onprem">On Premise</SelectItem>
                    <SelectItem value="odp">OmanDataPark</SelectItem>
                </Select>
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    Monthly spend (OMR)
                </Text>
                <NumberInput
                    value={inputs.monthlySpend}
                    onValueChange={(v) => setInputs({ monthlySpend: v })}
                    min={0}
                    step={10}
                    className="w-full md:w-48"
                />
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    Primary workload profile
                </Text>
                <Select
                    value={inputs.workload}
                    onValueChange={(v) =>
                        setInputs({
                            workload: (v as WorkloadProfile) || 'general',
                        })
                    }
                    className="w-full md:w-48"
                >
                    <SelectItem value="general">General</SelectItem>
                    <SelectItem value="compute">Compute-heavy</SelectItem>
                    <SelectItem value="storage">Storage-heavy</SelectItem>
                    <SelectItem value="transfer">
                        Data-transfer-heavy
                    </SelectItem>
                </Select>
            </Flex>
        </Card>
    )
}
